import { Role } from "@/enums";

export default [
  {
    path: "/",
    redirect: "/login",
    name: "Home",
    meta: {
      sidebar: false,
      header: false,
      paddingZero: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => {
      return import(
        /* webpackChunkName: "login" */ "@/views/login/LoginPage.vue"
      );
    },
    meta: {
      sidebar: false,
      header: false,
      paddingZero: true,
    },
  },
  {
    path: "/login/admin",
    name: "AdminLogin",
    component: () => {
      return import(
        /* webpackChunkName: "login" */ "@/views/login/AdminLoginPage.vue"
      );
    },
    meta: {
      sidebar: false,
      header: false,
      paddingZero: true,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => {
      return import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/RouteDashboard.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/lessons",
    name: "lessons-catalog",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/RouteLessons.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
    },
  },
  {
    path: "/lessons/create",
    name: "lesson-create",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/LessonCreate.vue"
      );
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/lessons/:id(\\d+)",
    name: "lesson-single",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/LessonOverview.vue"
      );
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
    },
    children: [
      {
        path: "overview",
        name: "lesson-overview",
        component: () => {
          return import(
            /* webpackChunkName: "lesson" */ "@/views/lessons/LessonOverviewInfo.vue"
          );
        },
        props: true,
        meta: {
          requiresAuth: true,
          sidebar: true,
          header: true,
          noFillHeight: true,
        },
      },
      {
        path: "students",
        name: "lesson-students",
        component: () => {
          return import(
            /* webpackChunkName: "lesson" */ "@/views/lessons/LessonOverviewStudents.vue"
          );
        },
        props: true,
        meta: {
          requiresAuth: true,
          sidebar: true,
          header: true,
          noFillHeight: true,
        },
      },
    ],
  },
  {
    path: "/lessons/:id(\\d+)/course",
    name: "lesson",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/LessonPage.vue"
      );
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/lessons/:courseId(\\d+)/test",
    name: "test",
    component: () => {
      return import(/* webpackChunkName: "lesson" */ "@/views/TestPage.vue");
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: false,
      header: false,
    },
  },
  {
    path: "/lessons/:id(\\d+)/edit/test",
    name: "lesson-edit-test",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/LessonEditTest.vue"
      );
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lessons/:id(\\d+)/edit/info",
    name: "lesson-edit-info",
    component: () => {
      return import(
        /* webpackChunkName: "lesson" */ "@/views/lessons/LessonEditGeneralInfo.vue"
      );
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/learning",
    name: "your-learning",
    component: () => {
      return import(
        /* webpackChunkName: "your-learning" */ "@/views/YourLearningPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      semesterSelection: Role.STUDENT,
      roleVisibility: Role.STUDENT,
    },
  },
  {
    path: "/user/favourites",
    name: "your-favourites",
    component: () => {
      return import(
        /* webpackChunkName: "your-favourites" */ "@/views/YourFavouritesPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      roleVisibility: Role.MANAGER | Role.MANAGER_CC | Role.TEACHER,
    },
  },
  {
    path: "/user/lessons",
    name: "your-lessons",
    component: () => {
      return import(
        /* webpackChunkName: "your-lessons" */ "@/views/YourLessonsPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      semesterSelection: Role.TEACHER,
      roleVisibility: Role.TEACHER,
    },
  },
  {
    path: "/questions",
    name: "all-questions",
    component: () => {
      return import(
        /* webpackChunkName: "question" */ "@/views/AllQuestions.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/questions/:id(\\d+)",
    name: "question",
    component: () => {
      return import(
        /* webpackChunkName: "question" */ "@/views/QuestionPage.vue"
      );
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/users",
    name: "users-list",
    component: () => {
      return import(
        /* webpackChunkName: "user" */ "@/views/users/UsersListView.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      roleVisibility: Role.ADMIN,
    },
  },
  {
    path: "/users/:userId(\\d+)",
    name: "user-info",
    component: () => {
      return import(
        /* webpackChunkName: "user" */ "@/views/users/UserInfo.vue"
      );
    },
    props: true,
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      semesterSelection:
        Role.ADMIN | Role.MANAGER | Role.MANAGER_CC | Role.TEACHER,
    },
  },
  {
    path: "/mngm/students/enroll",
    name: "enroll-students",
    component: () => {
      return import(
        /* webpackChunkName: "enroll-students" */ "@/views/EnrollStudent.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      roleVisibility: Role.ADMIN,
    },
  },
  {
    path: "/team",
    name: "team",
    component: () => {
      return import(/* webpackChunkName: "team" */ "@/views/TeamPage.vue");
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      semesterSelection: Role.ADMIN | Role.MANAGER | Role.MANAGER_CC,
      roleVisibility: Role.ADMIN | Role.MANAGER | Role.MANAGER_CC,
    },
  },
  {
    path: "/documentation",
    name: "documentation",
    component: () => {
      return import(
        /* webpackChunkName: "documentation" */ "@/views/DocumentationPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      semesterSelection:
        Role.ADMIN |
        Role.MANAGER |
        Role.MANAGER_CC |
        Role.TEACHER |
        Role.STUDENT,
    },
  },
  {
    path: "/need-help",
    name: "need-help",
    component: () => {
      return import(
        /* webpackChunkName: "need-help" */ "@/views/NeedHelpPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
    },
  },
  {
    path: "/reports",
    name: "reports",
    component: () => {
      return import(
        /* webpackChunkName: "reports" */ "@/views/ReportsPage.vue"
      );
    },
    meta: {
      requiresAuth: true,
      sidebar: true,
      header: true,
      noFillHeight: true,
      roleVisibility: Role.ADMIN | Role.MANAGER | Role.MANAGER_CC,
    },
  },
];
